(function () {
  "use strict";

  // const slider = new Swiper(".mySwiper", {
  //   pagination: {
  //     el: ".swiper-pagination",
  //   },
  // });

  function mainNavigation() {
    const navigation = new Navigation(document.getElementById("navigation"), {
      //breakpoint: 1024,
      //overlay: false,
      //overlayColor: "#31A6FF",
      // onInit: function () {
      //   alert("Initialized");
      // }
    });
  }

  function heroSlider() {
    if (document.querySelector(".hero-slider")) {
      const swiper = new Swiper(".hero-slider .swiper", {
        loop: true,
        grabCursor: true,
        effect: "creative",
        creativeEffect: {
          prev: {
            shadow: true,
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".hero-slider .slider-button-next",
          prevEl: ".hero-slider .slider-button-prev",
        },
      });
    }
  }

  // Foto Slider
  function fotoSlider() {
    if (document.querySelector(".foto-slider")) {
      const slider = new Swiper(".foto-slider .swiper", {
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 1500,
          // disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".foto-slider .slider-button-next",
          prevEl: ".foto-slider .slider-button-prev",
        },
      });
    }
  }

  // Fancybox
  function initFancybox() {
    if (typeof Fancybox !== 'undefined') {
      Fancybox.bind("[data-fancybox]", {
        // Your custom options
      });
    }
  }

  // Intl Tel Input

  function telefonInput() {
    const input = document.querySelector("#phone");
    window.intlTelInput(input, {
      // allowDropdown: false,
      // autoPlaceholder: "off",
      // containerClass: "test",
      // countryOrder: ["jp", "kr"],
      // customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
      //   return "e.g. " + selectedCountryPlaceholder;
      // },
      // dropdownContainer: document.querySelector('#custom-container'),
      // excludeCountries: ["us"],
      // fixDropdownWidth: false,
      // formatAsYouType: false,
      // formatOnDisplay: false,
      // geoIpLookup: function(callback) {
      //   fetch("https://ipapi.co/json")
      //     .then(function(res) { return res.json(); })
      //     .then(function(data) { callback(data.country_code); })
      //     .catch(function() { callback(); });
      // },
      // hiddenInput: () => "phone_full",
      // i18n: { 'de': 'Deutschland' },
      initialCountry: "us",
      // nationalMode: false,
      // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
      // placeholderNumberType: "MOBILE",
      // showFlags: false,
      // separateDialCode: true,
      // strictMode: true,
      // useFullscreenPopup: true,
      utilsScript: "./utils.js",
    });
  }

  // Scroll top Button

  function scrollTop() {
    const btnScrollTop = document.getElementById("scrollTop");
    document.addEventListener("scroll", () => {
      if (window.scrollY > 1000) {
        btnScrollTop.classList.remove("hide-btn");
      } else {
        btnScrollTop.classList.add("hide-btn");
      }
    });

    btnScrollTop.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  // mainNavigation();
  heroSlider();
  // telefonInput()
  fotoSlider();
  initFancybox();
  // videoSlider()
  // videoSayfaSlider()
  // deneyimSlider()
  // initAcc('.accordion.v1', true);
  // uygulamalarSlider()
  // scrollTop()
})();
